const e=async(e,t,n,r={})=>{await e.post(`/users/${t}/roles/${n}`,r)};export{e as assignRole};
//# sourceMappingURL=assign-role.mjs.map